/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_AllocationInputs */

const en_nav_allocation = /** @type {(inputs: Nav_AllocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allocation`)
};

/**
* | output |
* | --- |
* | "Allocation" |
*
* @param {Nav_AllocationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_allocation = /** @type {((inputs?: Nav_AllocationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_AllocationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_allocation(inputs)
});